import { render, staticRenderFns } from "./dr-widget-list.vue?vue&type=template&id=915cf0fc&"
import script from "./dr-widget-list.vue?vue&type=script&lang=js&"
export * from "./dr-widget-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../player/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports